import { styled } from "@mui/material/styles";
import useApi from "../hooks/useApi";
import { route } from "preact-router";
import searchingGif from "../assets/loading.gif";

import {
  Box,
  FormControl,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import Button from "@mui/material/Button";

import { useCallback, useEffect, useRef, useState } from "preact/hooks";

import { analyitcsApi } from "../api/controller/analytics";
import { formatDate, startOfDay, endOfDay, addMinutes } from "date-fns";

import { CustomProvider, DateRangePicker } from "rsuite";
import "rsuite/DateRangePicker/styles/index.css";
import RecentRequest from "./recentRequest";
import { Fragment } from "preact";
import Header from "./common/header";
import { useMediaQuery, useOnClickOutside } from "usehooks-ts";

const RecentlyPlayedWrapper = styled("div")`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: ${(props) =>
    props.showDashboard ? "flex-start" : "center"};

  align-items: center;
  gap: 8px;
  .recentlyPlayedListWrapper {
    max-height: 600px;
    width: 100%;
    overflow-y: auto;
  }
  .headerText {
    color: #f7f7f7;
    font-size: 32px;
    font-weight: 600;
    line-height: 48px;
    text-align: center;
  }
  .songIcon {
    height: 48px;
    width: 48px;
    border-radius: 12px;
    margin-right: 10px;
  }
  .viewAll {
    position: absolute;
    width: 96px;
    min-height: 32px;
    top: 0;
    right: 0;
    cursor: pointer;
    height: fit-content;
    padding: 0px 8px;
    border: 0;
    box-sizing: border-box;
    border-radius: 44px;
    box-shadow: -1px 1px 10px #f0c3f1;
    background-color: #1c1c1e;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .songsListContainer {
    display: flex;
    align-items: center;
    justify-content: start;
    margin-top: 20px;
    text-align: left;
  }
  .indexText {
    color: #c4c4c4;
    font-size: 14px;
    line-height: 18px;
    margin-right: 10px;
  }

  .analytics-cta {
    max-width: 600px;
    width: 100%;
    min-width: 250px;
    text-transform: none;
    line-height: 60px;
    margin-top: 30px;
    height: 60px;
    padding: 0px 8px;
    border: 0;
    box-sizing: border-box;
    border-radius: 16px;
    box-shadow: -1px 1px 10px #f0c3f1;
    background-color: #6741d9;
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    outline: none;
    font-family: Poppins;
  }
  .analytics-cta:hover {
    border: #f0c3f1 1px solid;
    background-color: #6741d9;
  }
  .analytics-cta:disabled {
    background-color: #4c4c4c;
    color: #a1a1a1;
  }

  .react-calendar {
    background: #1c1c1e;
    border: none;
    border-radius: 12px;
  }
  .react-calendar--selectRange .react-calendar__tile--hover {
    background: #2a2a2a;
    background-color: #2a2a2a;
  }
  .react-calendar__tile--hover {
    background: #2a2a2a;
    background-color: #2a2a2a;
  }
  .react-calendar__tile--hoverEnd {
    background: #2a2a2a;
  }
  .react-calendar__tile:enabled:hover {
    background: #2a2a2a;
  }
  .react-calendar__tile:focus {
    background: #2a2a2a;
    background-color: #2a2a2a;
  }
  .react-calendar__tile--now {
    background: #6741d9;
  }
  .react-calendar__tile--hasActive {
    background: #6741d9;
  }
  .react-calendar__tile--active {
    background: #3a3a3a;
  }
  .react-calendar__tile--rangeStart {
    background: #5735c1;
  }
  .react-daterange-picker__clear-button__icon {
    stroke: white;
  }
  .react-daterange-picker__calendar-button__icon {
    stroke: white;
  }
  .react-calendar__navigation button:enabled:hover {
    background: #2a2a2a;
  }
  .react-calendar__tile--hasActive {
    background: #6741d9;
  }
  .react-calendar__tile--active {
    background: #3a3a3a;
  }
  .react-calendar__month-view__days__day--weekend {
    color: #f0c3f1;
  }
  .react-daterange-picker__inputGroup {
    font-size: 12px;
  }
  .react-daterange-picker__wrapper {
    // border-radius: 50px;
    border: none;
    height: 40px;
    padding: 4px;
    // width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .react-calendar__navigation button:enabled:focus {
    background: #2b2b2b;
  }
  .react-calendar__navigation button:disabled {
    background: #585858;
  }
  .react-calendar__navigation button:disabled:focus {
    background: #585858;
  }
  .react-calendar__tile:disabled {
    background: #585858;
  }
  .react-calendar__tile:disabled:focus {
    background: #585858;
  }
  .react-calendar__tile:enabled:focus {
    background: #2b2b2b;
  }
  .react-calendar__tile--rangeStart {
    background: #a587ff;
  }
  .react-calendar__tile--rangeEnd {
    background: #a587ff;
  }

  .rs-input-group-inside {
    border: none;
    background-color: transparent !important;
    &:focus {
      border: none;
    }
    input {
      text-align: right;
      background-color: transparent !important;
    }
  }
`;

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#6741d9",
    },
  },
});
function RecentlyPlayed({ isPlayedScreen, recentlyPlayedSongs }) {
  const [selectedAnalyticsDuration, setSelectedAnalyticsDuration] =
    useState("month");
  const [analyticsSongs, setAnalyticsSongs] = useState([]);
  const [showDashboard, setShowDashboard] = useState(false);
  const [analyticsData, setAnalyticsData] = useState();
  const [showPicker, setShowPicker] = useState(false);

  const [playlistSongsoffset, setPlaylistSongsoffset] = useState(0);
  const [playlistEndReached, setPlaylistEndReached] = useState(0);
  const [open, setOpen] = useState(false);
  const limit = 50;
  const analyticsDataRequest = useApi();
  const [dateRange, onDateChange] = useState();
  const analyticsRef = useRef([]);

  const getAnalyticsData = (offset) => {
    const startDate = dateRange ? startOfDay(dateRange[0]) : new Date();
    const endDate = dateRange ? endOfDay(dateRange[1]) : new Date();
    return analyitcsApi(
      analyticsDataRequest.request,
      selectedAnalyticsDuration,
      limit,
      offset,
      {
        isCustom: selectedAnalyticsDuration === "custom",
        startDate: formatDate(
          addMinutes(startDate, startDate.getTimezoneOffset()),
          "yyyy-MM-dd HH:mm"
        ),
        endDate: formatDate(
          addMinutes(endDate, endDate.getTimezoneOffset()),
          "yyyy-MM-dd HH:mm"
        ),
      }
    );
  };

  useEffect(() => {
    if (selectedAnalyticsDuration && selectedAnalyticsDuration !== "custom") {
      setPlaylistSongsoffset(0);
      getAnalyticsData(0);
    }
  }, [selectedAnalyticsDuration]);

  useEffect(() => {
    if (
      dateRange &&
      selectedAnalyticsDuration &&
      selectedAnalyticsDuration === "custom"
    ) {
      console.log(dateRange);
      setPlaylistSongsoffset(0);
      getAnalyticsData(0);
    }
  }, [dateRange]);

  useEffect(() => {
    setTimeout(() => {
      setAnalyticsData(undefined);
      setAnalyticsSongs([]);
      onDateChange(undefined);
    }, 0);
  }, [selectedAnalyticsDuration]);

  useEffect(() => {
    if (analyticsDataRequest.data && analyticsDataRequest.data?.data) {
      setAnalyticsData(analyticsDataRequest.data.data);
    }
  }, [analyticsDataRequest.data]);

  const handleAnalyticDropdown = (e) => {
    setSelectedAnalyticsDuration(e.target.value);
    setOpen(!open);
  };

  useEffect(() => {
    if (
      analyticsDataRequest.data &&
      analyticsDataRequest.data.data &&
      analyticsDataRequest.data.data.recent_requests
    ) {
      // If there is data, update the state variables

      setAnalyticsSongs((analyticsSongs) =>
        playlistSongsoffset == 0 // If we are reloading the state, reset tracks list
          ? [...analyticsDataRequest.data.data.recent_requests]
          : [
              ...analyticsSongs,
              ...analyticsDataRequest.data.data.recent_requests,
            ]
      );

      if (analyticsDataRequest.data.data.recent_requests.length == 0) {
        setPlaylistEndReached(true);
      }
      if (playlistSongsoffset == 0) {
        setPlaylistEndReached(false);
      }
    } else {
      // If there is no data, set playlistSongs state to an empty array
      setAnalyticsSongs([]);
      setPlaylistSongsoffset(0);
    }
  }, [analyticsDataRequest.data]);

  const requestAnalyticsData = (offset) => {
    if (!playlistEndReached) {
      getAnalyticsData(offset);
    } else {
      setPlaylistSongsoffset(offset - 1);
    }
  };

  const isMobile = useMediaQuery("(max-width: 724px)");
  const pickerRef = useRef(null);

  const getDateFormat = (isMobile) => {
    console.log("isMobile", isMobile);
    return isMobile ? "dd-M-yy" : "dd-MM-yy";
  };

  useOnClickOutside([pickerRef], () => {
    setShowPicker(false);
  });

  return (
    <>
      <Header />
      <RecentlyPlayedWrapper style={{ width: "100%" }}>
        <div className="headerText">Recently Played Songs</div>
        <ThemeProvider theme={darkTheme}>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
              position: "relative",
            }}
          >
            <Box
              sx={{
                maxWidth: "600px",
                width: "100%",
                paddingTop: "10px",
                position: "relative",
              }}
            >
              <FormControl fullWidth>
                <Select
                  open={open}
                  onClick={() => {
                    setOpen(true);
                    setShowPicker(false);
                  }}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedAnalyticsDuration ?? ""}
                  label="Duration"
                  placeholder="Select Duration"
                  onChange={(e) => {
                    handleAnalyticDropdown(e);
                    setOpen(false);
                    if (e.target.value === "custom") {
                      setShowPicker(true);
                    }
                  }}
                  sx={{
                    display: "flex",
                    borderRadius: "999px",
                    alignItems: "flex-start",
                    textAlign: "left",
                    outline: "none",
                    backgroundColor: "#1c1c1e",
                    boxShadow: "-1px 1px 10px #f0c3f1",
                    "& .MuiPaper-root": {
                      borderRadius: "1rem",
                    },
                  }}
                  input={<OutlinedInput />}
                >
                  <MenuItem value={"month"}>This Month</MenuItem>
                  <MenuItem value={"week"}>This Week</MenuItem>
                  <MenuItem value={"last_24"}>Last 24 Hrs</MenuItem>
                  <MenuItem
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    value={"custom"}
                  >
                    Custom
                  </MenuItem>
                </Select>
              </FormControl>
              {selectedAnalyticsDuration === "custom" && (
                <Paper
                  sx={{
                    // transform: "translateX(-100px)",
                    zIndex: "9999",
                    position: "absolute",
                    right: "14px",
                    top: "22.5px",
                    boxShadow: "none",
                    background: "#1c1c1e !important",
                    width: "100%",
                    maxWidth: isMobile ? "180px" : "220px",
                  }}
                >
                  <CustomProvider theme="dark">
                    <DateRangePicker
                      ref={pickerRef}
                      onChange={(value) => {
                        setShowPicker(false);
                        onDateChange(value);
                      }}
                      open={showPicker}
                      value={dateRange}
                      size="sm"
                      shouldDisableDate={DateRangePicker.afterToday()}
                      ranges={[]}
                      editable={false}
                      format={getDateFormat(isMobile)}
                      placeholder="Select dates"
                      onClick={() => {
                        setShowPicker(true);
                        setOpen(false);
                      }}
                      onClean={() => {
                        setAnalyticsSongs([]);
                        setAnalyticsData([]);
                      }}
                      showOneCalendar
                    />
                  </CustomProvider>
                </Paper>
              )}
            </Box>
          </div>
        </ThemeProvider>
        {/* <div className={isPlayedScreen ? "recentlyPlayedListWrapper" : ""}>
          {recentlyPlayedSongs?.map((request, index) =>
            isPlayedScreen || (!isPlayedScreen && index < 3) ? (
              <div
                className="songsListContainer"
                key={`${request.id}-${index}`}
              >
                {isPlayedScreen && <div className="indexText">{index + 1}</div>}
                <div>
                  <img src={request.logo} alt="" className="songIcon" />
                </div>
                <div>
                  <div
                    className="songName"
                    style={!isPlayedScreen && { maxWidth: "25vw" }}
                  >
                    {request.title}
                  </div>
                  <div
                    className="songArtist"
                    style={!isPlayedScreen && { maxWidth: "26vw" }}
                  >
                    {request.album} | {request.artist}
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )
          )}
        </div> */}

        {analyticsDataRequest.loading && playlistSongsoffset === 0 ? (
          <div
            style={{
              justifyContent: "center",
              display: "flex",
              height: "80vh",
              width: "100%",
              overflow: "hidden",
              flexDirection: "column",
              boxShadow: "0px 2px 10px rgba(3, 3, 3, 0.1)",
              fontWeight: "600",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                fontFamily: "Poppins",
                fontSize: "12px",
                fontWeight: "600",
              }}
            >
              Loading...
            </div>
          </div>
        ) : (
          <RecentRequest
            isPlayedScreen={true}
            recentlyPlayedSongs={analyticsSongs}
            playlistSongsoffset={playlistSongsoffset}
            setPlaylistSongsoffset={setPlaylistSongsoffset}
            requestAnalyticsData={requestAnalyticsData}
            playlistEndReached={playlistEndReached}
          />
        )}
      </RecentlyPlayedWrapper>
    </>
  );
}

export default RecentlyPlayed;
